"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FormaciNDeLite() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const stages = [{
    numeral: "I",
    title: "Selección Rigurosa",
    body: "Cada aspirante se somete a un proceso exhaustivo de control de confianza. Evaluamos antecedentes, perfiles psicológicos y aptitudes físicas bajo estándares nacionales. Solo el personal con integridad comprobada avanza a nuestra academia de formación táctica.",
    closing: "La seguridad comienza con el carácter del individuo.",
    offset: "md:ml-0"
  }, {
    numeral: "II",
    title: "Formación Táctica",
    body: "Nuestro personal recibe adiestramiento especializado en defensa personal, manejo de crisis y protocolos de vigilancia. La capacitación es continua y obligatoria, asegurando que cada guardia domine las técnicas más avanzadas de protección y disuasión.",
    closing: "La disciplina es nuestra mayor herramienta de defensa.",
    offset: "md:ml-12"
  }, {
    numeral: "III",
    title: "Certificación y Control",
    body: "Validamos las competencias mediante certificaciones oficiales y pruebas de desempeño en campo. El personal es instruido en el uso de tecnología de punta y sistemas de comunicación encriptada, garantizando una respuesta coordinada ante cualquier eventualidad.",
    closing: "La competencia técnica garantiza la tranquilidad del cliente.",
    offset: "md:ml-24"
  }, {
    numeral: "IV",
    title: "Despliegue Estratégico",
    body: "Una vez certificados, los elementos son asignados según su perfil a servicios específicos: intramuros, escoltas o patrullaje. Mantenemos una supervisión 24/7 y evaluaciones periódicas para asegurar que el estándar Poseidón se mantenga inalterable.",
    closing: "Protección absoluta a través de la vigilancia constante.",
    offset: "md:ml-36"
  }];
  return <section data-section-id="4639" id="formación-de-élite" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-16 transition-all duration-1000 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="md:col-span-7">
            <p className="font-mono text-xs tracking-[0.3em] uppercase mb-10 text-primary">
              Capacitación / II
            </p>
            <h2 className="font-default font-bold leading-[0.95] text-5xl md:text-7xl lg:text-8xl uppercase">
              Formación de{" "}
              <span className="text-primary">
                Élite
              </span>
            </h2>
          </div>
          <div className="md:col-span-5 md:pt-16">
            <p className="font-default text-xl md:text-2xl leading-relaxed text-muted-foreground">
              En Grupo Poseidón, no solo contratamos personal; forjamos especialistas en protección. Nuestra academia garantiza que cada elemento sea un baluarte de confianza y profesionalismo.
            </p>
          </div>
        </div>

        {}
        <div className="mt-20 mb-20 h-px w-full bg-border" />

        {}
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-20">
          {}
          <div className="lg:col-span-8 relative">
            {}
            <div className="absolute left-2 md:left-4 top-0 bottom-0 w-px hidden md:block bg-border" aria-hidden="true" />

            <ol className="space-y-24 md:space-y-32">
              {stages.map((stage, i) => {
              return <TimelineStage key={i} data-index={i} stage={stage} />;
            })}
            </ol>
          </div>

          {}
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-24">
              <div className="relative overflow-hidden shadow-xl" style={{
              aspectRatio: "3 / 5"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_security_training_academy.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_security_training_academy.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_security_training_academy.png-wvc-sizes" alt="Personal de seguridad en formación táctica profesional" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover grayscale hover:grayscale-0 transition-all duration-700" />
              </div>
              <p className="font-mono text-[0.65rem] tracking-[0.25em] uppercase mt-4 text-primary">
                Registro § 04 — Academia Poseidón, Entrenamiento Táctico
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="mt-24 mb-16 h-px w-full bg-border" />

        {}
        <div className="text-center max-w-3xl mx-auto">
          <p className="font-default font-medium text-2xl md:text-3xl leading-relaxed mb-10 text-foreground">
            Seguridad respaldada por el mejor capital humano del sector.
          </p>
          <Link to="/ContactPage">
            <Button variant="outline" size="lg" className="font-mono text-xs tracking-[0.3em] uppercase h-14 px-10 rounded-md border-2 bg-primary text-primary-foreground hover:bg-foreground hover:text-background transition-colors duration-500">
              Solicitar Personal Capacitado
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}
function TimelineStage({
  stage,
  ...props
}: {
  stage: {
    numeral: string;
    title: string;
    body: string;
    closing: string;
    offset: string;
  };
  [key: string]: any;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLLIElement>({
    threshold: 0.15
  });
  return <li ref={ref} {...props} className={`relative ${stage.offset} transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <div className="grid grid-cols-12 gap-4 md:gap-8">
        {}
        <div className="col-span-2 md:col-span-2 relative">
          <span className="font-serif font-light italic block leading-none text-5xl md:text-7xl lg:text-8xl text-primary/20">
            {stage.numeral}
          </span>
        </div>

        {}
        <div className="col-span-10 md:col-span-10 pt-2 md:pt-4">
          <h3 className="font-default font-bold text-2xl md:text-3xl lg:text-4xl leading-tight mb-6 text-foreground uppercase">
            {stage.numeral}.{" "}
            <span className="font-light">{stage.title}</span>
          </h3>
          <p className="font-default text-lg md:text-xl leading-relaxed mb-6 max-w-2xl text-muted-foreground">
            {stage.body}
          </p>
          <p className="font-mono italic text-base md:text-lg leading-relaxed max-w-xl text-primary">
            — {stage.closing}
          </p>
        </div>
      </div>
    </li>;
}